import React from "react";
import Vector from "../../../../../Assets/Images/Empty-notif.svg";

const EmptyState = (props) => {
  return (
    <div className="empty-state">
      <img alt="" src={Vector} />
      <h1>{props.Text}</h1>
    </div>
  );
};

export default EmptyState;
